module.exports = __webpack_public_path__ + "static/media/home-book.0ddcc140.png";